import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { RequestUserResponse } from "@/types";

export type UpdateUserRequestFormData = {
  id: string;
  data: FormData;
};

export async function updateUser(
  userData: UpdateUserRequestFormData
): Promise<RequestUserResponse> {
  const { id, ...updateData } = userData;

  // The route is `PUT users/{user}`; PHP only parses multipart bodies on POST,
  // so the avatar upload goes as POST with Laravel's method override.
  updateData.data.set("_method", "PUT");

  const response = await httpRequest.post<RequestUserResponse>(
    `/users/${id}`,
    updateData.data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function useUpdateUserMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}
